"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDebounceManager = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Creates a debounce manager for the given function
 * Use case: a debounced function (eg. change handler) has to be synchronized in order to work with the most recent data
 * Note: invokeSync and sync can work with async/await (result forwarding)
 * @author boda@redhotmagma.de
 * @param {function} callbackFn
 * @param {number} delay The delay in ms
 */
var createDebounceManager = exports.createDebounceManager = function createDebounceManager(callbackFn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var lastChangeTimeout;
  var needsInvocation = false;
  var storedArgs = [];
  var invokeStored = function invokeStored() {
    if (needsInvocation) {
      needsInvocation = false;
      return callbackFn.apply(void 0, _toConsumableArray(storedArgs));
    }
  };
  return {
    /**
     * @param args
     * @return {*}
     */
    invokeSync: function invokeSync() {
      window.clearTimeout(lastChangeTimeout);
      needsInvocation = false;
      return callbackFn.apply(void 0, arguments);
    },
    /**
     * @param args
     */
    invokeDebounced: function invokeDebounced() {
      window.clearTimeout(lastChangeTimeout);
      needsInvocation = true;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      storedArgs = args;
      lastChangeTimeout = window.setTimeout(invokeStored, delay);
    },
    /**
     * @return {*}
     */
    sync: function sync() {
      window.clearTimeout(lastChangeTimeout);
      return invokeStored();
    }
  };
};